import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/puramas-cn/htdocs/cn.puramas.co/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/puramas-cn/htdocs/cn.puramas.co/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/puramas-cn/htdocs/cn.puramas.co/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/puramas-cn/htdocs/cn.puramas.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/puramas-cn/htdocs/cn.puramas.co/node_modules/next/dist/client/image-component.js");
